<template>
  <topics-table :view="view" :row-click-enabled="false"/>
</template>

<script>
import { mapState } from 'vuex'
import topicsTable from './table'

export default {
  components: {
    topicsTable
  },
  computed: {
    ...mapState('tenants', {
      view: '_archivedView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/topics/archived.vue